export default {
    title: 'Panels',
    add: {
        button: 'Create panel'
    },
    status: {
        true: 'Trend radar evaluation active',
        false: 'Trend radar evaluation inactive',
        tooltip: {
            true: 'Deactivate all ratings in this trend radar',
            false: 'Activate all ratings in this trend radar'
        }
    }
}
